import { render, staticRenderFns } from "./AddNewCanteenStaffMember.vue?vue&type=template&id=60ec6f8d&"
import script from "./AddNewCanteenStaffMember.vue?vue&type=script&lang=js&"
export * from "./AddNewCanteenStaffMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports